import React, { useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import Portal from '@mui/material/Portal';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MonthlyTrendPreview from './MonthlyTrendPreview';

export default function DashDrawer({ open, onClose, filters }) {
    
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        if (open) {
            window.addEventListener('keydown', handleKeyDown);
        }
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [open, onClose]);


    let contextConfig = { contextType: '', title: 'Analytics View', subtitle: '' };
    const rawContext = sessionStorage.getItem('dash_drawer_context');
    if (rawContext) {
        try {
            contextConfig = JSON.parse(rawContext);
        } catch (e) {
            console.error("Error parsing drawer storage blueprint:", e);
        }
    }

    return (
        <Portal>
            <Drawer
                anchor="right"
                open={open}
                onClose={onClose}
                disablePortal={false}
                sx={{
                    zIndex: 99999,
                    '& .MuiDrawer-paper': {
                        width: '100%',
                        maxWidth: '950px',
                        boxShadow: '-12px 0 48px rgba(8, 26, 45, 0.25)',
                        border: 'none',
                        backgroundColor: '#f8fafc',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        zIndex: 100000,
                    },
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(8, 26, 45, 0.35)',
                        backdropFilter: 'blur(5px)',
                        zIndex: 99998,
                    },
                }}
            >
                {/* FIXED UNIFIED HEADER CONTAINER */}
                <div className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 px-6 py-4 flex items-center justify-between shrink-0 shadow-sm">
                    <div>
                        <h2 className="text-sm font-bold tracking-tight text-slate-900 uppercase">{contextConfig.title}</h2>
                        {contextConfig.subtitle && (
                            <p className="text-[11px] text-slate-500 mt-0.5 font-medium">{contextConfig.subtitle}</p>
                        )}
                    </div>
                    <button 
                        onClick={onClose} 
                        className="p-1.5 text-slate-400 hover:text-slate-900 hover:bg-slate-100 rounded-md transition-all duration-200"
                    >
                        <CloseRoundedIcon sx={{ fontSize: 18 }} />
                    </button>
                </div>

                {/* CONTENT AREA TRACK */}
                <div className="flex-1 overflow-y-auto w-full relative z-0">
                    {contextConfig.contextType === 'monthlyTrend' ? (
                        <MonthlyTrendPreview globalFilters={filters} />
                    ) : (
                        <div className="flex items-center justify-center h-full text-slate-400 font-medium text-xs">
                            No preview runtime layout matched.
                        </div>
                    )}
                </div>
            </Drawer>
        </Portal>
    );
}